import { GeocoderAutocomplete } from '@geoapify/geocoder-autocomplete';

(function jqueryYpGeoComplete($) {
    window.$.fn.geocomplete = function ypGeocomplete() {
        // Stop submit form when input is focused and enter key is pressed
        this.on('keydown', (e) => {
            if (e.keyCode === 13) {
                e.preventDefault();
            }
        });

        /* eslint-disable-next-line no-new */
        return new GeocoderAutocomplete(
            this.get(0), // Unwrap the native DOM element
            env.GEOAPIFY_KEY, {
                type: 'amenity',
                lang: 'fr',
                placeholder: ' ',
                debounceDelay: 500,
            },
        );
    };
}(window.jQuery));
